/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { DashboardGameModel, DashboardGameModelType } from './DashboardGameModel'
import { DashboardGameModelSelector } from './DashboardGameModel.base'
import { PaginationInfoModel, PaginationInfoModelType } from './PaginationInfoModel'
import { PaginationInfoModelSelector } from './PaginationInfoModel.base'
import { RootStoreType } from './index'

/**
 * PaginatedGamesDetailsResponseBase
 * auto generated base class for the model PaginatedGamesDetailsResponseModel.
 */
export const PaginatedGamesDetailsResponseModelBase = ModelBase.named('PaginatedGamesDetailsResponse')
  .props({
    __typename: types.optional(types.literal('PaginatedGamesDetailsResponse'), 'PaginatedGamesDetailsResponse'),
    games: types.union(types.undefined, types.array(types.late(() => DashboardGameModel))),
    pagination: types.union(
      types.undefined,
      types.late(() => PaginationInfoModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PaginatedGamesDetailsResponseModelSelector extends QueryBuilder {
  games(
    builder:
      | string
      | DashboardGameModelSelector
      | ((selector: DashboardGameModelSelector) => DashboardGameModelSelector)
      | undefined
  ) {
    return this.__child('games', DashboardGameModelSelector, builder)
  }
  pagination(
    builder:
      | string
      | PaginationInfoModelSelector
      | ((selector: PaginationInfoModelSelector) => PaginationInfoModelSelector)
      | undefined
  ) {
    return this.__child('pagination', PaginationInfoModelSelector, builder)
  }
}
export function selectFromPaginatedGamesDetailsResponse() {
  return new PaginatedGamesDetailsResponseModelSelector()
}

export const paginatedGamesDetailsResponseModelPrimitives = selectFromPaginatedGamesDetailsResponse()
